import { createAddGenericActivityUrl } from "src/constants/urls";
import { useMutation } from "src/lib/tanstack-query/hooks/use-mutation";
import { useRouterLocale } from "src/utils/router/use-router-locale";

export enum EnumActivityType {
    InvestButtonPressed = 300,
    InvestViaBrokerlinkPressed = 301,
    CreateSavingsPlanViaBrokerLinkClicked = 302,
    VisitWikifolioDetailPage = 400,
    ShowBenchmarksClicked = 401,
    VisitWikifolioSearchPage = 500,
    SearchViewSwitched = 501,
    SearchCustomFiguresSelected = 502,
    RegisterShowInvestorModalRequestPhoneSupport = 1003,
    ContentPageVisit = 1100,
    MarketIndicatorPageVisit = 1200,
    MagazineArticleStarred = 1500,
    NewsArticleLiked = 1510,
    PodcastArticleLiked = 1520,
    VwoExperimentSeen = 1600,
    VwoExperimentClicked = 1610,
    FunnelQuestionnaireAnswer = 1900,
    ActionOptionSelected = 1901,
    LikedTraderComment = 2000,
    CommentLiked = 2020,
    VisitedSmartFeed = 2100,
    VisitedWatchlist = 2101,
    VisitedPortfolio = 2102,
    WatchlistCustomFiguresSelected = 2120,
    NavigationClicked = 2200,
    NewsletterSubscriptionLinkClicked = 2300,
    StickyMessageBannerSeen = 2400,
    StickyMessageBannerClicked = 2401,
    AdClicked = 2500,
    TopTraderReactionsUnderlyingSeen = 2601,
    ReactionsRevealed = 2602,
    HelpscoutMessageClicked = 2700,
    VideoArticleClicked = 2800,
    PodcastPlayClicked = 2810,
    PodcastListened = 2811,
}

interface IRequest {
    activityTypeId: EnumActivityType;
    parameter?: string | null;
}

export const useGenericActivityMutation = () => {
    const { language, country } = useRouterLocale();
    const { mutatePromise } = useMutation<void, void, IRequest>(createAddGenericActivityUrl(language, country));

    return mutatePromise;
};
